module.exports = __webpack_public_path__ + "assets/img/information_1.383095f3.svg";